import type { ColumnDef } from "@tanstack/react-table";

import type { Product } from "@/types";

export const buildColumns = (): ColumnDef<Product>[] => [
  {
    accessorKey: "id",
    header: "ID",
    enableSorting: false,
  },
  {
    accessorKey: "internal_code",
    header: "Código Interno",
    enableSorting: false,
    cell: ({ row }) => {
      const internalCode = row.original.internal_code;
      return internalCode ? (
        <span className="text-muted-foreground">{internalCode}</span>
      ) : (
        <span className="text-muted-foreground">-</span>
      );
    },
  },
  {
    accessorKey: "normalized_name",
    header: "Nombre",
    enableSorting: false,
    cell: ({ row }) => row.original.normalized_name,
  },
  {
    accessorKey: "category_name",
    id: "category_name",
    header: "Categoría",
    enableSorting: false,
    cell: ({ row }) => {
      const category = row.original.category;
      return category ? (
        category.name
      ) : (
        <span className="text-muted-foreground">-</span>
      );
    },
  },
  {
    accessorKey: "subcategory_name",
    id: "subcategory_name",
    header: "Subcategoría",
    enableSorting: false,
    cell: ({ row }) => {
      const subcategory = row.original.subcategory;
      return subcategory ? (
        subcategory.name
      ) : (
        <span className="text-muted-foreground">-</span>
      );
    },
  },
];
